/*
 * context
 */
export var SELECT_OUTCOME_IDS = 'SELECT_OUTCOME_IDS';
export var SET_ERROR = 'SET_ERROR';
export var SET_OUTCOMES = 'SET_OUTCOMES';
export var SET_OUTCOME_PICKER_STATE = 'SET_OUTCOME_PICKER_STATE';
export var SET_ROOT_OUTCOME_IDS = 'SET_ROOT_OUTCOME_IDS';
export var SET_SELECTED_OUTCOME_IDS = 'SET_SELECTED_OUTCOME_IDS';
export var UNSELECT_OUTCOME_IDS = 'UNSELECT_OUTCOME_IDS';
export var SET_SCORING_METHOD = 'SET_SCORING_METHOD';
export var SET_FEATURES = 'SET_FEATURES';
/*
 * alignments
 */

export var SET_ALIGNMENTS = 'SET_ALIGNMENTS';
export var VIEW_ALIGNMENT = 'VIEW_ALIGNMENT';
export var CLOSE_ALIGNMENT = 'CLOSE_ALIGNMENT';
export var UPDATE_ALIGNMENT = 'UPDATE_ALIGNMENT';
/*
 * picker
 */

export var SET_FOCUSED_OUTCOME = 'SET_FOCUSED_OUTCOME';
export var SET_ACTIVE_COLLECTION_ID = 'SET_ACTIVE_COLLECTION_ID';
export var TOGGLE_EXPANDED_IDS = 'TOGGLE_EXPANDED_IDS';
export var SET_SCOPE = 'SET_SCOPE';
export var RESET_OUTCOME_PICKER = 'RESET_OUTCOME_PICKER';
/*
 * reporting
 */

export var SET_REPORT_PAGE = 'SET_REPORT_PAGE';
export var SET_REPORT_PAGE_DATA = 'SET_PAGE_DATA';
export var SET_REPORT_OUTCOMES = 'SET_REPORT_OUTCOMES';
export var SET_REPORT_ROLLUPS = 'SET_REPORT_ROLLUPS';
export var SET_REPORT_RESULTS = 'SET_REPORT_RESULTS';
export var SET_REPORT_USERS = 'SET_REPORT_USERS';
export var SET_REPORT_LOADING = 'SET_REPORT_LOADING';
export var VIEW_REPORT_ALIGNMENT = 'VIEW_REPORT_ALIGNMENT';
export var CLOSE_REPORT_ALIGNMENT = 'CLOSE_REPORT_ALIGNMENT';
/*
 * search
 */

export var SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export var SET_SEARCH_PAGE = 'SET_SEARCH_PAGE';
export var SET_SEARCH_LOADING = 'SET_SEARCH_LOADING';
export var SET_SEARCH_ENTRIES = 'SET_SEARCH_ENTRIES';
export var SET_SEARCH_TOTAL = 'SET_SEARCH_TOTAL';
/*
* tray
*/

export var SET_OUTCOME_LIST = 'SET_OUTCOME_LIST';
export var SET_LIST_PAGE = 'SET_LIST_PAGE';
export var SET_LIST_TOTAL = 'SET_LIST_TOTAL';
/*
 * student mastery
 */

export var SET_INDIVIDUAL_RESULTS = 'SET_INDIVIDUAL_RESULTS';
export var SET_INDIVIDUAL_RESULTS_STATE = 'SET_INDIVIDUAL_RESULTS_STATE';